import AppInstallGuide from '~/components/Guide/AppInstallGuide';
import Entry from '~/pages/Entry/Entry';
import GlobalSuspenseFallback from '~/pages/Fallback/GlobalSuspenseFallback';

import { useAppEnv } from './useAppEnv';

/**
 * @description 루트 경로(`/`) 전용 Guard
 * - 브릿지 응답 대기 중: 로딩 화면 (앱 설치 가이드 노출 방지)
 * - 브릿지 무응답(failed): throw → 상위 ErrorBoundary가 에러 화면 표시
 * - 웹뷰/개발 모드: Entry, 브라우저: AppInstallGuide
 *
 * 경로가 겹치는 `/`는 Navigate가 아닌 직접 렌더로 분기하여 무한 리다이렉트를 방지한다.
 */
const RootGuard = () => {
  const { bridgeStatus, isWebView, isDevMode } = useAppEnv();

  if (!isDevMode && bridgeStatus === 'pending') {
    return <GlobalSuspenseFallback />;
  }

  if (!isDevMode && bridgeStatus === 'failed') {
    throw new Error('앱 정보를 확인할 수 없습니다.');
  }

  return isWebView || isDevMode ? <Entry /> : <AppInstallGuide />;
};

export default RootGuard;
